import CampaignIcon from '@mui/icons-material/Campaign';
import { Theme } from '@mui/material';

import { MessageItem } from '@/components/RunningMessagesBanner';

export const DEFAULT_OPERATIONAL_MESSAGE =
  'System maintenance scheduled for tonight at 11 PM. All employee share plan transactions will be temporarily unavailable. We appreciate your patience as we enhance our platform. Downtime is expected to last approximately 2 hours.';
export const DEFAULT_COMPANY_ANNOUNCEMENT =
  'Q4 2025 LTIP Vesting Cycle has been completed successfully. All eligible employees can now view their updated share allocations in the Shares.Vision dashboard. Please log in to review your vested shares and plan for the upcoming fiscal year.';
export const DEFAULT_NOTIFICATION_MESSAGE =
  'Action required: Please review and approve pending share plan documents. You have 3 documents awaiting your attention. Click here to view details.';

/** Shared by the live landing page and the admin preview, so the two agree. */
export const getDefaultRunningMessages = (theme: Theme): MessageItem[] => [
  {
    id: 'operational',
    title: 'Operational Messages',
    icon: <CampaignIcon />,
    content: DEFAULT_OPERATIONAL_MESSAGE,
    color: '#E58686',
  },
  {
    id: 'company-announcement',
    title: 'Company Announcements',
    icon: <CampaignIcon />,
    content: DEFAULT_COMPANY_ANNOUNCEMENT,
    color: theme.palette.primary.main,
  },
  {
    id: 'notification',
    title: 'Notification Messages',
    icon: <CampaignIcon />,
    content: DEFAULT_NOTIFICATION_MESSAGE,
    color: '#E2C959',
  },
];
